// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2019 Kevin Verdieck, originally developed at Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
.mosaic {
  height: 100%;
  width: 100%;
}
.mosaic,
.mosaic > * {
  box-sizing: border-box;
}
.mosaic .mosaic-zero-state {
  position: absolute;
  top: 6px;
  right: 6px;
  bottom: 6px;
  left: 6px;
  width: auto;
  height: auto;
  z-index: 1;
}
.mosaic-root {
  position: absolute;
  top: 3px;
  right: 3px;
  bottom: 3px;
  left: 3px;
}
.mosaic-split {
  position: absolute;
  z-index: 1;
  touch-action: none;
}
.mosaic-split:hover {
  background: black;
}
.mosaic-split .mosaic-split-line {
  position: absolute;
}
.mosaic-split.-row {
  margin-left: -3px;
  width: 6px;
  cursor: ew-resize;
}
.mosaic-split.-row .mosaic-split-line {
  top: 0;
  bottom: 0;
  left: 3px;
  right: 3px;
}
.mosaic-split.-column {
  margin-top: -3px;
  height: 6px;
  cursor: ns-resize;
}
.mosaic-split.-column .mosaic-split-line {
  top: 3px;
  bottom: 3px;
  left: 0;
  right: 0;
}
.mosaic-tile {
  position: absolute;
  margin: 3px;
}
.mosaic-tile > * {
  height: 100%;
  width: 100%;
}
.mosaic-drop-target {
  position: relative;
}
.mosaic-drop-target.drop-target-hover .drop-target-container {
  display: block;
}
.mosaic-drop-target.mosaic > .drop-target-container .drop-target.left {
  right: calc(100% -  10px );
}
.mosaic-drop-target.mosaic > .drop-target-container .drop-target.right {
  left: calc(100% -  10px );
}
.mosaic-drop-target.mosaic > .drop-target-container .drop-target.bottom {
  top: calc(100% -  10px );
}
.mosaic-drop-target.mosaic > .drop-target-container .drop-target.top {
  bottom: calc(100% -  10px );
}
.mosaic-drop-target .drop-target-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
}
.mosaic-drop-target .drop-target-container.-dragging {
  display: block;
}
.mosaic-drop-target .drop-target-container .drop-target {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  border: 2px solid black;
  opacity: 0;
  z-index: 5;
}
.mosaic-drop-target .drop-target-container .drop-target.left {
  right: calc(100% -  30% );
}
.mosaic-drop-target .drop-target-container .drop-target.right {
  left: calc(100% -  30% );
}
.mosaic-drop-target .drop-target-container .drop-target.bottom {
  top: calc(100% -  30% );
}
.mosaic-drop-target .drop-target-container .drop-target.top {
  bottom: calc(100% -  30% );
}
.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover {
  opacity: 1;
}
.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.left {
  right: calc(100% -  50% );
}
.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.right {
  left: calc(100% -  50% );
}
.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.bottom {
  top: calc(100% -  50% );
}
.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.top {
  bottom: calc(100% -  50% );
}
.mosaic-window,
.mosaic-preview {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
}
.mosaic-window .mosaic-window-toolbar,
.mosaic-preview .mosaic-window-toolbar {
  z-index: 4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  height: 30px;
  background: white;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}
.mosaic-window .mosaic-window-toolbar.draggable,
.mosaic-preview .mosaic-window-toolbar.draggable {
  cursor: move;
}
.mosaic-window .mosaic-window-title,
.mosaic-preview .mosaic-window-title {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 15px;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-height: 18px;
}
.mosaic-window .mosaic-window-controls,
.mosaic-preview .mosaic-window-controls {
  display: flex;
  height: 100%;
}
.mosaic-window .mosaic-window-controls .separator,
.mosaic-preview .mosaic-window-controls .separator {
  height: 20px;
  border-left: 1px solid black;
  margin: 5px 4px;
}
.mosaic-window .mosaic-window-body,
.mosaic-preview .mosaic-window-body {
  position: relative;
  flex: 1;
  height: 0;
  background: white;
  z-index: 1;
  overflow: hidden;
}
.mosaic-window .mosaic-window-additional-actions-bar,
.mosaic-preview .mosaic-window-additional-actions-bar {
  position: absolute;
  top: 30px;
  right: 0;
  bottom: initial;
  left: 0;
  height: 0;
  overflow: hidden;
  background: white;
  justify-content: flex-end;
  display: flex;
  z-index: 3;
}
.mosaic-window .mosaic-window-additional-actions-bar .bp4-button,
.mosaic-preview .mosaic-window-additional-actions-bar .bp4-button {
  margin: 0;
}
.mosaic-window .mosaic-window-additional-actions-bar .bp4-button:after,
.mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:after {
  display: none;
}
.mosaic-window .mosaic-window-body-overlay,
.mosaic-preview .mosaic-window-body-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  background: white;
  display: none;
  z-index: 2;
}
.mosaic-window.additional-controls-open .mosaic-window-additional-actions-bar,
.mosaic-preview.additional-controls-open .mosaic-window-additional-actions-bar {
  height: 30px;
}
.mosaic-window.additional-controls-open .mosaic-window-body-overlay,
.mosaic-preview.additional-controls-open .mosaic-window-body-overlay {
  display: block;
}
.mosaic-window .mosaic-preview,
.mosaic-preview .mosaic-preview {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 0;
  border: 1px solid black;
  max-height: 400px;
}
.mosaic-window .mosaic-preview .mosaic-window-body,
.mosaic-preview .mosaic-preview .mosaic-window-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mosaic-window .mosaic-preview h4,
.mosaic-preview .mosaic-preview h4 {
  margin-bottom: 10px;
}
.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.close-button:before {
  content: 'Close';
}
.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.split-button:before {
  content: 'Split';
}
.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.replace-button:before {
  content: 'Replace';
}
.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.expand-button:before {
  content: 'Expand';
}
.mosaic.mosaic-blueprint-theme {
  background: #abb3bf;
}
.mosaic.mosaic-blueprint-theme .mosaic-zero-state {
  background: #e5e8eb;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);
}
.mosaic.mosaic-blueprint-theme .mosaic-zero-state .default-zero-state-icon {
  font-size: 120px;
}
.mosaic.mosaic-blueprint-theme .mosaic-split:hover {
  background: none;
}
.mosaic.mosaic-blueprint-theme .mosaic-split:hover .mosaic-split-line {
  box-shadow: 0 0 0 1px #4c90f0;
}
.mosaic.mosaic-blueprint-theme.mosaic-drop-target .drop-target-container .drop-target,
.mosaic.mosaic-blueprint-theme .mosaic-drop-target .drop-target-container .drop-target {
  background: rgba(138, 187, 255, 0.2);
  border: 2px solid #4c90f0;
  transition: opacity 100ms;
  border-radius: 2px;
}
.mosaic.mosaic-blueprint-theme .mosaic-window,
.mosaic.mosaic-blueprint-theme .mosaic-preview {
  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);
  border-radius: 2px;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar {
  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.15);
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar.draggable:hover,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar.draggable:hover {
  background: linear-gradient(to bottom, #fff, #f6f7f9);
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar.draggable:hover .mosaic-window-title,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar.draggable:hover .mosaic-window-title {
  color: #111418;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-title,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-title {
  font-weight: 600;
  color: #404854;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .separator,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .separator {
  border-left: 1px solid #dce0e5;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .bp4-button,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .bp4-button,
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .bp4-button:before,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .bp4-button:before {
  color: #738091;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .default-preview-icon,
.mosaic.mosaic-blueprint-theme .mosaic-preview .default-preview-icon {
  font-size: 72px;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-body,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-body {
  border-top-width: 0;
  background: #f6f7f9;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar {
  transition: height 250ms;
  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.15);
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar .bp4-button,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button,
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar .bp4-button:before,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:before {
  color: #738091;
}
.mosaic.mosaic-blueprint-theme .mosaic-window.additional-controls-open .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme .mosaic-preview.additional-controls-open .mosaic-window-toolbar {
  box-shadow: 0 1px 0 0 0 0 1px rgba(17, 20, 24, 0.15);
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-preview,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-preview {
  border: 1px solid #8f99a8;
}
.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-preview h4,
.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-preview h4 {
  color: #404854;
}
.mosaic.mosaic-blueprint-theme.bp4-dark {
  background: #252a31;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-zero-state {
  background: #383e47;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-split:hover .mosaic-split-line {
  box-shadow: 0 0 0 1px #2d72d2;
}
.mosaic.mosaic-blueprint-theme.bp4-dark.mosaic-drop-target .drop-target-container .drop-target,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-drop-target .drop-target-container .drop-target {
  background: rgba(33, 93, 176, 0.2);
  border-color: #2d72d2;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window-additional-actions-bar {
  background: #383e47;
  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.4);
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-toolbar.draggable:hover,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-toolbar.draggable:hover {
  background: linear-gradient(to bottom, #404854, #383e47);
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-toolbar.draggable:hover .mosaic-window-title,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-toolbar.draggable:hover .mosaic-window-title {
  color: #fff;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-title,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-title {
  color: #dce0e5;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .separator,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .separator {
  border-color: #5f6b7c;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .bp4-button,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .bp4-button,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .bp4-button:before,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .bp4-button:before {
  color: #abb3bf;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-body,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-body {
  background: #252a31;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-additional-actions-bar .bp4-button,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-additional-actions-bar .bp4-button:before,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:before {
  color: #c5cbd3;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window.additional-controls-open .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview.additional-controls-open .mosaic-window-toolbar {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-preview,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-preview {
  border-color: #5f6b7c;
}
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-preview h4,
.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-preview h4 {
  color: #edeff2;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-mosaic-component/react-mosaic-component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;AACF;EACE,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,MAAM;EACN,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,WAAW;EACX,OAAO;EACP,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;;EAEE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;EAEE,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;;EAEE,4CAA4C;EAC5C,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,qDAAqD;AACvD;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,8BAA8B;AAChC;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;;EAEE,wBAAwB;EACxB,4CAA4C;AAC9C;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,oDAAoD;AACtD;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;;EAEE,oDAAoD;AACtD;AACA;;EAEE,wDAAwD;AAC1D;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,oDAAoD;AACtD;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB","sourcesContent":["/**\n * @license\n * Copyright 2019 Kevin Verdieck, originally developed at Palantir Technologies, Inc.\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *     http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n.mosaic {\n  height: 100%;\n  width: 100%;\n}\n.mosaic,\n.mosaic > * {\n  box-sizing: border-box;\n}\n.mosaic .mosaic-zero-state {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  bottom: 6px;\n  left: 6px;\n  width: auto;\n  height: auto;\n  z-index: 1;\n}\n.mosaic-root {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  bottom: 3px;\n  left: 3px;\n}\n.mosaic-split {\n  position: absolute;\n  z-index: 1;\n  touch-action: none;\n}\n.mosaic-split:hover {\n  background: black;\n}\n.mosaic-split .mosaic-split-line {\n  position: absolute;\n}\n.mosaic-split.-row {\n  margin-left: -3px;\n  width: 6px;\n  cursor: ew-resize;\n}\n.mosaic-split.-row .mosaic-split-line {\n  top: 0;\n  bottom: 0;\n  left: 3px;\n  right: 3px;\n}\n.mosaic-split.-column {\n  margin-top: -3px;\n  height: 6px;\n  cursor: ns-resize;\n}\n.mosaic-split.-column .mosaic-split-line {\n  top: 3px;\n  bottom: 3px;\n  left: 0;\n  right: 0;\n}\n.mosaic-tile {\n  position: absolute;\n  margin: 3px;\n}\n.mosaic-tile > * {\n  height: 100%;\n  width: 100%;\n}\n.mosaic-drop-target {\n  position: relative;\n}\n.mosaic-drop-target.drop-target-hover .drop-target-container {\n  display: block;\n}\n.mosaic-drop-target.mosaic > .drop-target-container .drop-target.left {\n  right: calc(100% -  10px );\n}\n.mosaic-drop-target.mosaic > .drop-target-container .drop-target.right {\n  left: calc(100% -  10px );\n}\n.mosaic-drop-target.mosaic > .drop-target-container .drop-target.bottom {\n  top: calc(100% -  10px );\n}\n.mosaic-drop-target.mosaic > .drop-target-container .drop-target.top {\n  bottom: calc(100% -  10px );\n}\n.mosaic-drop-target .drop-target-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: none;\n}\n.mosaic-drop-target .drop-target-container.-dragging {\n  display: block;\n}\n.mosaic-drop-target .drop-target-container .drop-target {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.2);\n  border: 2px solid black;\n  opacity: 0;\n  z-index: 5;\n}\n.mosaic-drop-target .drop-target-container .drop-target.left {\n  right: calc(100% -  30% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.right {\n  left: calc(100% -  30% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.bottom {\n  top: calc(100% -  30% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.top {\n  bottom: calc(100% -  30% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover {\n  opacity: 1;\n}\n.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.left {\n  right: calc(100% -  50% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.right {\n  left: calc(100% -  50% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.bottom {\n  top: calc(100% -  50% );\n}\n.mosaic-drop-target .drop-target-container .drop-target.drop-target-hover.top {\n  bottom: calc(100% -  50% );\n}\n.mosaic-window,\n.mosaic-preview {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);\n}\n.mosaic-window .mosaic-window-toolbar,\n.mosaic-preview .mosaic-window-toolbar {\n  z-index: 4;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  height: 30px;\n  background: white;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\n}\n.mosaic-window .mosaic-window-toolbar.draggable,\n.mosaic-preview .mosaic-window-toolbar.draggable {\n  cursor: move;\n}\n.mosaic-window .mosaic-window-title,\n.mosaic-preview .mosaic-window-title {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding-left: 15px;\n  flex: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  min-height: 18px;\n}\n.mosaic-window .mosaic-window-controls,\n.mosaic-preview .mosaic-window-controls {\n  display: flex;\n  height: 100%;\n}\n.mosaic-window .mosaic-window-controls .separator,\n.mosaic-preview .mosaic-window-controls .separator {\n  height: 20px;\n  border-left: 1px solid black;\n  margin: 5px 4px;\n}\n.mosaic-window .mosaic-window-body,\n.mosaic-preview .mosaic-window-body {\n  position: relative;\n  flex: 1;\n  height: 0;\n  background: white;\n  z-index: 1;\n  overflow: hidden;\n}\n.mosaic-window .mosaic-window-additional-actions-bar,\n.mosaic-preview .mosaic-window-additional-actions-bar {\n  position: absolute;\n  top: 30px;\n  right: 0;\n  bottom: initial;\n  left: 0;\n  height: 0;\n  overflow: hidden;\n  background: white;\n  justify-content: flex-end;\n  display: flex;\n  z-index: 3;\n}\n.mosaic-window .mosaic-window-additional-actions-bar .bp4-button,\n.mosaic-preview .mosaic-window-additional-actions-bar .bp4-button {\n  margin: 0;\n}\n.mosaic-window .mosaic-window-additional-actions-bar .bp4-button:after,\n.mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:after {\n  display: none;\n}\n.mosaic-window .mosaic-window-body-overlay,\n.mosaic-preview .mosaic-window-body-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  background: white;\n  display: none;\n  z-index: 2;\n}\n.mosaic-window.additional-controls-open .mosaic-window-additional-actions-bar,\n.mosaic-preview.additional-controls-open .mosaic-window-additional-actions-bar {\n  height: 30px;\n}\n.mosaic-window.additional-controls-open .mosaic-window-body-overlay,\n.mosaic-preview.additional-controls-open .mosaic-window-body-overlay {\n  display: block;\n}\n.mosaic-window .mosaic-preview,\n.mosaic-preview .mosaic-preview {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 0;\n  border: 1px solid black;\n  max-height: 400px;\n}\n.mosaic-window .mosaic-preview .mosaic-window-body,\n.mosaic-preview .mosaic-preview .mosaic-window-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.mosaic-window .mosaic-preview h4,\n.mosaic-preview .mosaic-preview h4 {\n  margin-bottom: 10px;\n}\n.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.close-button:before {\n  content: 'Close';\n}\n.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.split-button:before {\n  content: 'Split';\n}\n.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.replace-button:before {\n  content: 'Replace';\n}\n.mosaic:not(.mosaic-blueprint-theme) .mosaic-default-control.expand-button:before {\n  content: 'Expand';\n}\n.mosaic.mosaic-blueprint-theme {\n  background: #abb3bf;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-zero-state {\n  background: #e5e8eb;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.mosaic.mosaic-blueprint-theme .mosaic-zero-state .default-zero-state-icon {\n  font-size: 120px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-split:hover {\n  background: none;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-split:hover .mosaic-split-line {\n  box-shadow: 0 0 0 1px #4c90f0;\n}\n.mosaic.mosaic-blueprint-theme.mosaic-drop-target .drop-target-container .drop-target,\n.mosaic.mosaic-blueprint-theme .mosaic-drop-target .drop-target-container .drop-target {\n  background: rgba(138, 187, 255, 0.2);\n  border: 2px solid #4c90f0;\n  transition: opacity 100ms;\n  border-radius: 2px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window,\n.mosaic.mosaic-blueprint-theme .mosaic-preview {\n  box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15);\n  border-radius: 2px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar {\n  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.15);\n  border-top-right-radius: 2px;\n  border-top-left-radius: 2px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar.draggable:hover,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar.draggable:hover {\n  background: linear-gradient(to bottom, #fff, #f6f7f9);\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-toolbar.draggable:hover .mosaic-window-title,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-toolbar.draggable:hover .mosaic-window-title {\n  color: #111418;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-title,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-title {\n  font-weight: 600;\n  color: #404854;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .separator,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .separator {\n  border-left: 1px solid #dce0e5;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .bp4-button,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .bp4-button,\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-controls .bp4-button:before,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-controls .bp4-button:before {\n  color: #738091;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .default-preview-icon,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .default-preview-icon {\n  font-size: 72px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-body,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-body {\n  border-top-width: 0;\n  background: #f6f7f9;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar {\n  transition: height 250ms;\n  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.15);\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar .bp4-button,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button,\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-window-additional-actions-bar .bp4-button:before,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:before {\n  color: #738091;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window.additional-controls-open .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme .mosaic-preview.additional-controls-open .mosaic-window-toolbar {\n  box-shadow: 0 1px 0 0 0 0 1px rgba(17, 20, 24, 0.15);\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-preview,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-preview {\n  border: 1px solid #8f99a8;\n}\n.mosaic.mosaic-blueprint-theme .mosaic-window .mosaic-preview h4,\n.mosaic.mosaic-blueprint-theme .mosaic-preview .mosaic-preview h4 {\n  color: #404854;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark {\n  background: #252a31;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-zero-state {\n  background: #383e47;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-split:hover .mosaic-split-line {\n  box-shadow: 0 0 0 1px #2d72d2;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark.mosaic-drop-target .drop-target-container .drop-target,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-drop-target .drop-target-container .drop-target {\n  background: rgba(33, 93, 176, 0.2);\n  border-color: #2d72d2;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window-additional-actions-bar {\n  background: #383e47;\n  box-shadow: 0 1px 1px rgba(17, 20, 24, 0.4);\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-toolbar.draggable:hover,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-toolbar.draggable:hover {\n  background: linear-gradient(to bottom, #404854, #383e47);\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-toolbar.draggable:hover .mosaic-window-title,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-toolbar.draggable:hover .mosaic-window-title {\n  color: #fff;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-title,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-title {\n  color: #dce0e5;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .separator,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .separator {\n  border-color: #5f6b7c;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .bp4-button,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .bp4-button,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-controls .bp4-button:before,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-controls .bp4-button:before {\n  color: #abb3bf;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-body,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-body {\n  background: #252a31;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-additional-actions-bar .bp4-button,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-window-additional-actions-bar .bp4-button:before,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-window-additional-actions-bar .bp4-button:before {\n  color: #c5cbd3;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window.additional-controls-open .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview.additional-controls-open .mosaic-window-toolbar {\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-preview,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-preview {\n  border-color: #5f6b7c;\n}\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-window .mosaic-preview h4,\n.mosaic.mosaic-blueprint-theme.bp4-dark .mosaic-preview .mosaic-preview h4 {\n  color: #edeff2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
